import {makeGetDistrictsHealthGuide} from 'main/factories/usecases/private/guide-flow/remote-medical-guide/get-districts-factory';
import {HealthDistrictsGuideParams} from './types';

export async function getHealthDistrictsGuide(params: HealthDistrictsGuideParams) {
	const response = await makeGetDistrictsHealthGuide().get(params);

	if (!Array.isArray(response) || response.length === 0) {
		return [];
	}

	return response.filter(district => district?.bairro);
}
